export default __webpack_public_path__ + "718f190879404f1cca562689f30a75f3.webp";